import { Radiobutton } from '../Radiobutton/Radiobutton';
import { Container } from './MultiRadiobutton.styles';
import { IRadiobutton } from './MultiRadiobutton.types';

export const MultipleRadiobutton = ({
  options,
  activeOption,
  label,
  user,
  children,
  padding,
  spacing,
  onChange,
}: IRadiobutton): JSX.Element => (
  <Container padding={padding} gap={spacing}>
    {label}
    {options.map(option => {
      return (
        <Radiobutton
          key={option.value}
          checked={activeOption === option.value}
          labelText={option.label}
          onClick={onChange.bind(undefined, option.value)}
          user={user}
        />
      );
    })}
    {children ?? null}
  </Container>
);
